import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const ButtonText = styled.p`
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 13px;
  font-style: normal;
  font-weight: 800;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  margin: 0;
`;
